/**
 * Jeden odcinek rozbicia. Dwa podtypy, bo właściciel etykiety jest inny:
 * `KEYED` opisuje stan wyliczony przez backend (front zna dla niego napis
 * i ton), `LABELED` odsyła do rekordu katalogowego, który sam niesie nazwę
 * i kolor — zmiana nazwy kategorii przemianowuje historię.
 */
export enum StatSegmentType {
  KEYED = 'KEYED',
  LABELED = 'LABELED',
}

export interface KeyedStatSegmentDto {
  type: StatSegmentType.KEYED;
  /** Stała backendu, tłumaczona przez rejestr widgetu. Nigdy tekst dla oka. */
  key: string;
  value: number;
}

export interface LabeledStatSegmentDto {
  type: StatSegmentType.LABELED;
  id: string;
  label: string;
  /**
   * `#RRGGBB` z katalogu. `null` znaczy „katalog nie ma barwy” — wtedy odcinek
   * bierze kolor z `CHART_SERIES_COLORS` po indeksie.
   */
  color: string | null;
  value: number;
}

export type StatSegmentDto = KeyedStatSegmentDto | LabeledStatSegmentDto;
